import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { notifyUser } from "../utils/notifyUser";

export default function VerifyResetEmail() {
    const [form, setForm] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
    });
    const [error] = useState("");
    const [success] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const token = new URLSearchParams(location.search).get("token");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleVerify = async (e) => {
        e.preventDefault();

        if(form.new_password !== form.confirm_password) {
            notifyUser(null, "error", "Passwords do not match", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }

        try {
            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-resetEmailPassword`,
                {
                    token,
                    current_password: form.current_password,
                    new_password: form.new_password,
                    confirm_password: form.confirm_password,
                },
            );

            notifyUser(null, "success", "Password updated successfully.", "toast", null, null, null, null, null, false, false, "top-center");
            setTimeout(() => navigate("/login"), 2000);
        } catch(err) {
            const backendMsg =
                err.response?.data?.message || err.response?.data?.error;
            // Show any backend password validation error as a toast
            if(backendMsg && backendMsg.toLowerCase().includes("password")) {
                notifyUser(null, "error", backendMsg, "toast", null, null, null, null, null, false, false, "top-center");
            } else if(backendMsg) {
                notifyUser(null, "error", backendMsg, "toast", null, null, null, null, null, false, false, "top-center");
            } else {
                notifyUser(null, "error", "Error updating password. Please try again.", "toast", null, null, null, null, null, false, false, "top-center");
            }
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 bg-white shadow-lg rounded-lg">
                <h2 className="text-2xl font-bold text-center mb-4">
                    Verify Your Email
                </h2>
                {error && (
                    <p className="text-red-500 text-sm text-center">{error}</p>
                )}
                {success && (
                    <p className="text-green-500 text-sm text-center">
                        {success}
                    </p>
                )}

                <form onSubmit={handleVerify} className="space-y-4">
                    <input
                        type="password"
                        name="current_password"
                        placeholder="Current Password"
                        value={form.current_password}
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                    <input
                        type="password"
                        name="new_password"
                        placeholder="New Password"
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                    <input
                        type="password"
                        name="confirm_password"
                        placeholder="Confirm New Password"
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                        required
                    />
                    <button
                        type="submit"
                        className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
}
